import { Component, DestroyRef, OnInit, ChangeDetectionStrategy, inject } from '@angular/core'
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private readonly router = inject(Router)
    private readonly destroy = inject(DestroyRef)

    public isLoading: boolean = false

    public ngOnInit(): void {
        this.router.events
            .pipe(takeUntilDestroyed(this.destroy))
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.isLoading = true
                }

                if (
                    event instanceof NavigationEnd
                    || event instanceof NavigationCancel
                    || event instanceof NavigationError
                ) {
                    this.isLoading = false
                }
            })
    }
}
